import { pki } from 'node-forge';

export const getExtractMetadataFromCertPemFn = () => (pem: string) => {
  const cert = pki.certificateFromPem(pem);

  const certCN = cert.subject.getField({ shortName: 'CN' }) as { value: string } | undefined;
  const certOU = cert.subject.getField({ shortName: 'OU' }) as { value: string } | undefined;

  return {
    tenantId: certOU?.value,
    dataplaneId: certCN?.value,
  };
};

export type ExtractMetadataFromCertPemFn = ReturnType<typeof getExtractMetadataFromCertPemFn>;
